import { TutorialDefinition } from '../TutorialEngine.js';
import { KnightRenderOptions } from './KnightTutorialAdapter.js';
import { COLORS } from '../../rendering/Renderer.js';

type KnightScene = {
    gameState: string;
    renderOptions: KnightRenderOptions;
    annotations: TutorialDefinition['scenes'][number]['annotations'];
    animate?: {
        interval: number;
        loop: boolean;
        frames: string[];
    };
};

// Full solution: B0-D1,B0-C2,C2-A3,A3-B5,D4-B5,E2-D4,E2-C3,D1-C3

const scenes: KnightScene[] = [
    // Scene 1: Goal — what a solved puzzle looks like
    {
        gameState: 'B0-D1,B0-C2,C2-A3,A3-B5,D4-B5,E2-D4,E2-C3,D1-C3',
        renderOptions: {},
        annotations: [
            { type: 'text-label', text: 'In Knight, trace a knight\'s\npath through all digits', cell: 'E0', anchor: 'center', color: COLORS.teal },
        ],
    },

    // Scene 2: The L-move
    {
        gameState: '+D3',
        renderOptions: {},
        annotations: [
            { type: 'text-label', text: 'Knight moves\nin an L-shape', cell: 'B0', anchor: 'center' },
            { type: 'text-label', text: 'Click anywhere\nto start a path', cell: 'C5', anchor: 'center' },
        ],
    },

    // Scene 3: Extending the path
    {
        gameState: 'B0-D1+D1',
        renderOptions: {},
        annotations: [
            { type: 'text-label', text: 'Click teal squares\nto extend the path', cell: 'B2', anchor: 'center', color: COLORS.teal },
            { type: 'pulse', cell: 'E3', color: COLORS.teal },
        ],
        animate: {
            interval: 1500,
            loop: true,
            frames: ['B0-D1+D1', 'B0-D1+D1,E3', 'B0-D1+D1,E3,F5', 'B0-D1+D1,E3,F5,D4']
        },
    },

    // Scene 4: Backtracking
    {
        gameState: 'B0-D1,D1-C3+C3',
        renderOptions: {},
        annotations: [
            { type: 'text-label', text: 'Click amber squares\nto backtrack', cell: 'B4', anchor: 'center', color: COLORS.amber },
            { type: 'pulse', cell: 'C3', color: COLORS.amber },
        ],
        animate: {
            interval: 1500,
            loop: true,
            frames: ['B0-D1,D1-C3+C3,E2', 'B0-D1,D1-C3+C3,E2,C3', 'B0-D1,D1-C3+C3,E2,C3,D1','B0-D1,D1-C3+C3,E2,C3']
        },
    },

    // Scene 5: Blocked jumps
    {
        gameState: 'B0-D1,D1-C3,C3-E2+E2',
        renderOptions: {},
        annotations: [
            { type: 'exclusion', cells: ['D0', 'C1'] },
            { type: 'text-label', text: 'Cannot jump\nthrough digits', cell: 'B2', anchor: 'center', color: COLORS.red },
        ],
    },

    // Scene 6: Digit sequence and disconnected segments
    {
        gameState: 'B0-D1,D1-C3,F0-E2+C3',
        renderOptions: {},
        annotations: [
            { type: 'text-label', text: 'Badges hint\nat next digit', cell: 'B1', anchor: 'center', color: COLORS.teal },
            { type: 'text-label', text: 'Amber paths are\ndisconnected', cell: 'E3', anchor: 'center', color: COLORS.amber },
            { type: 'text-label', text: 'Amber squares\nshow next', cell: 'B5', anchor: 'center', color: COLORS.amber },
        ],
    },

];

/**
 * Knight tutorial: 6 scenes on a 6x6 grid with digits 1-3.
 * See docs/tutorials/knight.md for detailed scene descriptions.
 */
export const KNIGHT_TUTORIAL: TutorialDefinition = {
    gameType: 'knight',
    gridCode: '6/1-3:1D1,2A3,3D4',
    scenes,
};
